import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Colabora } from 'src/models/colabora';
import { environment } from 'src/environments/environment';



@Injectable({
  providedIn: 'root'
})
export class HomeServiceService {
  // local
  //apiURL = 'http://localhost:2393/';

  // test
  apiURL = environment.URL_API_MAGNO ;


  // test
  apiURLAniv = environment.URL_API_ANIV;

  constructor(private http: HttpClient) {
  }

  // Uses http.get() to load data from a single API endpoint
  getBoletoTablero() {
    const body = {};
    return this.http.post(`${this.apiURL}/api/TombolaBoleto`, body);
  }

  getBoletoTableroANIV() {
    const body = {};
    return this.http.post(`${this.apiURLAniv}/api/TombolaBoleto`, body);
  }


  getValidaBoleto(folio) {
    return this.http.get(`${this.apiURL}/api/BoletosWeb/ValidaBoleto/${folio}`);
  }
  postBoletoConditioned(obj) {
    return this.http.get(`${this.apiURL}/api/BoletosWeb/Seleccion`);
  }
  getLuckyBol(obj) {
    return this.http.get(`${this.apiURL}/api/BoletosWeb/GetLuckyBol_Perm`);
  }
  setLuckyBol(obj) { // Boletos enviados a Back para registrar como perpetuos
    return this.http.get(`${this.apiURL}/api/BoletosWeb/Registro_BoletoPerpetuo`);
  }
  getPopState() {  // Estado de Pop según DB
    return this.http.get(`${this.apiURL}/api/GetPopState`);
  }

  sendColabora(formulario: Colabora, tokenS: string) {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + tokenS
    });
    return this.http.post(`${this.apiURL}/api/Colaborador/RegistroColaboradorGeneral`, formulario, { headers });
  }

  // Token de seguridad para consultar la información de la campaña activa
  getToken() {
    const body = {
      "correo": "ejemplo@gmail.com",
      "tipo_usuario": "0",
      "tipo_seguridad": environment.ts
    };
    return this.http.post(`${this.apiURL}/api/Seguridad/Token`, body);
  }

  // Información de la campaña activa (imagen + descripción + redirección)
  getActiveZod(tokenS: string) {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + tokenS
    });
    return this.http.get(`${this.apiURL}/api/BoletosWeb/SeleccionInformacionZodiaco`, { headers });
  }

}
